// Mock data for AutoPostr Landing Page - Digital Marketing Focus

export const contentTypes = [
  { id: 1, text: "Faceless viral content", icon: "UserX" },
  { id: 2, text: "Affiliate marketing content", icon: "DollarSign" },
  { id: 3, text: "Digital product content", icon: "Package" },
  { id: 4, text: "Brand videos", icon: "Building2" },
  { id: 5, text: "Motivational & niche pages", icon: "TrendingUp" },
  { id: 6, text: "Repurposed long-form content", icon: "Repeat" },
  { id: 7, text: "PLR / MRR content", icon: "FileCheck" },
  { id: 8, text: "Your own videos", icon: "Upload" }
];

export const valuePoints = [
  { id: 1, text: "Driving traffic", icon: "Users" },
  { id: 2, text: "Promoting offers", icon: "Megaphone" },
  { id: 3, text: "Scaling income", icon: "TrendingUp" }
];

export const contentBundles = [
  {
    id: 1,
    title: "Luxury & Rich Lifestyle",
    count: "70,000+",
    description: "Cars • Yachts • Private Jets • Millionaire Lifestyle",
    icon: "Crown",
    gradient: "from-amber-500/20 to-yellow-500/20"
  },
  {
    id: 2,
    title: "Viral Short Videos",
    count: "100,000+",
    description: "Satisfying • Gaming • AI Animated • Funny • Pets • Gym",
    icon: "Flame",
    gradient: "from-red-500/20 to-orange-500/20"
  },
  {
    id: 3,
    title: "Motivational & Business",
    count: "12,000+",
    description: "Faceless • Inspirational • Quotes • Hustle Content",
    icon: "TrendingUp",
    gradient: "from-emerald-500/20 to-teal-500/20"
  },
  {
    id: 4,
    title: "Ready-to-Post Reels",
    count: "1,300+",
    description: "PLR / MRR Licensed • Viral Motivational Content",
    icon: "Rocket",
    gradient: "from-purple-500/20 to-pink-500/20"
  }
];

export const platforms = [
  { id: 1, name: "TikTok", icon: "Music2" },
  { id: 2, name: "Instagram Reels", icon: "Instagram" },
  { id: 3, name: "YouTube Shorts", icon: "Youtube" },
  { id: 4, name: "Facebook", icon: "Facebook" },
  { id: 5, name: "X (Twitter)", icon: "Twitter" }
];

export const contentSources = [
  { id: 1, name: "Our Viral Library", description: "100,000+ videos", icon: "Library" },
  { id: 2, name: "Google Drive", description: "Your own files", icon: "HardDrive" },
  { id: 3, name: "YouTube Channel", description: "Your existing videos", icon: "Youtube" },
  { id: 4, name: "Direct Upload", description: "Upload your library", icon: "Upload" }
];

export const howItWorks = [
  {
    id: 1,
    step: "01",
    title: "Sign Up",
    description: "Sign up with an email address and password to create your account."
  },
  {
    id: 2,
    step: "02",
    title: "Connect Your Accounts",
    description: "Connect your TikTok, Instagram, and YouTube accounts."
  },
  {
    id: 3,
    step: "03",
    title: "Post to All Platforms",
    description: "Post to all platforms at once in one click or schedule unlimited posts into the future."
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "AutoPostr Starter",
    price: 30,
    description: "Everything in Pro+ a starter dose of done-for-you posting.",
    features: [
      "Everything in Pro",
      "5 posts per day",
      "All 7 social platforms",
      "30 days of Automated Posting",
      "Full content library access",
      "Auto captions & hashtags",
      "Smart scheduling & timing",
      "Content recycling",
      "Priority support"
    ],
    popular: false
  },
  {
    id: 2,
    name: "AutoPostr Premium",
    price: 50,
    description: "Everything in Pro+ scaled for serious marketers and multi-page brands.",
    features: [
      "Everything in Pro",
      "10 posts per day",
      "All 7 social platforms",
      "30 days of Automated Posting",
      "Full content library access",
      "Auto captions & hashtags",
      "Smart scheduling & timing",
      "Content recycling",
      "Priority support"
    ],
    popular: true
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Alex Thompson",
    role: "Affiliate Marketer",
    avatar: "AT",
    content: "I grew my TikTok from 0 to 50K followers in 2 months. Now I'm driving consistent traffic to my affiliate offers without creating content daily."
  },
  {
    id: 2,
    name: "Maria Santos",
    role: "Digital Product Creator",
    avatar: "MS",
    content: "Managing 8 pages used to take my entire day. Now AutoPostr posts to all of them automatically while I focus on selling my courses."
  },
  {
    id: 3,
    name: "Jordan Lee",
    role: "Marketing Agency",
    avatar: "JL",
    content: "We use this for all our clients' social pages. The ROI is insane — consistent posting means consistent traffic and sales."
  }
];

export const faqs = [
  {
    id: 1,
    question: "What type of content can you post for me?",
    answer: "We can post faceless viral content, affiliate marketing content, digital product promos, brand videos, motivational content, repurposed long-form content, PLR/MRR content, or your own custom videos. You're not limited to one type."
  },
  {
    id: 2,
    question: "Can I use this to promote affiliate offers?",
    answer: "Absolutely! Many of our users are affiliate marketers who use consistent posting to drive traffic to their offers. The key is staying consistent, and we handle that for you."
  },
  {
    id: 3,
    question: "What if I want to use my own content?",
    answer: "No problem! You can connect your Google Drive, YouTube channel, or directly upload your video library. We'll schedule and post your content the same way we handle our viral library."
  },
  {
    id: 4,
    question: "How does this help me make money?",
    answer: "Consistent posting = consistent traffic. Whether you're promoting affiliate products, selling digital products, or building an audience to monetize later, we help you stay visible without the daily grind."
  },
  {
    id: 5,
    question: "Will my accounts get banned?",
    answer: "We use platform-specific posting caps, randomized posting windows, and human-like scheduling patterns. Your accounts are treated exactly as if a real person was posting manually."
  },
  {
    id: 6,
    question: "What's the difference between Starter and Pro?",
    answer: "Starter gives you 5 posts per day across all 7 platforms. AutoPostr Premium unlocks 10 posts per day across all 7 platforms, plus smart timing optimization and content recycling for maximum reach."
  }
];

export const comparisonItems = {
  whatWeDo: [
    "Monthly content distribution",
    "Multiple content types supported",
    "Platform-safe posting limits",
    "Human-like scheduling patterns",
    "Traffic-focused strategy",
    "Monetization-friendly approach"
  ],
  whatWeDont: [
    "Fake engagement or likes",
    "Bought followers or bots",
    "Copyrighted content",
    "Risky automation tactics",
    "Spam or aggressive posting",
    "Anything that risks your accounts"
  ]
};

export const stats = [
  { id: 1, value: "30", label: "Days of posting" },
  { id: 2, value: "10+", label: "Posts per day" },
  { id: 3, value: "7", label: "Platforms" },
  { id: 4, value: "0", label: "Daily work" }
];
